import { useEffect, useState } from "react"
import { useSelector } from "react-redux";

const Orders = () =>{
    const [orders, setorders] = useState([]);
    const {idk} = useSelector((state)=>state)
     const getorders = async () => {
        let resp = await fetch(`https://backend-ecomweb.onrender.com/api/getorders/${idk}`);
        if (resp.ok) {
            let res = await resp.json();
            setorders(res.ords);
        }
        else {
            alert("fail")
        }
    }

    useEffect(()=>{
        getorders();
    },[idk])


    return(
        <>
        <div className="cartbox">
        <table className="table mt-4">
            <tr>
                <th> Order Number  </th>
                <th> Products </th>
                <th> Cash </th>
                <th> Status </th>
                <th> Date </th>
            </tr>
                {
                    orders.map((data,ind)=>(
                        <tr key={ind}>
                            <td> {data.OrderNumber} </td>
                            <td>
                                <ul>
                                    {
                                    data.products.map((dat, ind)=>(
                                        <li key={ind}> {dat.title}  </li>
                                    ))
                                    }
                                
                                </ul>
                            </td>
                            <td> ${data.Cash} </td>
                            <td> {data.status} </td>
                            <td> {data.Date} </td>
                        </tr>
                        
                    ))
                }
        </table>
        </div>
        </>
    )
}

export default Orders;